'use strict';

var $cache = {},
  options = {},
  config = require('./carousel-config'),
  callbacks = ['onInitialize', 'onInitialized', 'onResize', 'onResized', 'onRefresh', 'onRefreshed', 'onDrag', 'onDragged', 'onTranslate', 'onTranslated', 'onChange', 'onChanged', 'onLoadLazy', 'onLoadedLazy', 'onStopVideo', 'onPlayVideo'];

function initializeParams(params) {
  options = $.extend(true, {}, config, params);
}

function initializeCache() {
  $cache.document = $(document);
}

function initOwlCarousel() {
  var $container = $(this),
    customConfig = $container.data('carouselOptions') || {},
    carouselOptions = $.extend({}, options, customConfig),
    $carousel = $container.find('.' + carouselOptions.baseClass),
    itemsLength = $carousel.find('.owl-carousel-item').length;

  for (var i in callbacks) {
    carouselOptions[callbacks[i]] = eventProxy($carousel, callbacks[i]);
  }

  carouselOptions.nav = itemsLength > 1 ? carouselOptions.nav : false;
  carouselOptions.loop = itemsLength > 1 ? carouselOptions.loop : false;

  $carousel.on('initialized.owl.carousel', function(e) {
    e.item.count < e.page.size ? $(this).addClass('owl-hide-controls') : $(this).removeClass('owl-hide-controls');
  });

  if ($(window).width() > 1024 && carouselOptions.showThumbnailsNavigation && itemsLength > 4) {
    carouselOptions.dots = false;
    carouselOptions.dotsContainer = '';

    $carousel.owlCarousel(carouselOptions).on('changed.owl.carousel', function(el) {
      syncPosition(el, $container);
    });

    initThumbnailsCarousel($container, $carousel);
  } else {
    $carousel.owlCarousel(carouselOptions);
  }


  // Button for scrolling a thumbnails list to the end instantly
  $(".js-scroll-pdp-thumbnails--bottom").click(function() {
    let thumbsContainer = $(".js-pdp-thumbnails");
    let scrollHeight = thumbsContainer[0].scrollHeight;
    thumbsContainer.animate({
      scrollTop: scrollHeight
    }, 400, 'swing');
  });

  $(".js-scroll-pdp-thumbnails--top").click(function() {
    let thumbsContainer = $(".js-pdp-thumbnails");
    thumbsContainer.animate({
      scrollTop: 0
    }, 400, 'swing');
  });

}

function initThumbnailsCarousel(container, carousel) {
  var thumbnails = container.find('.b-pdp-thumbnail_list');

  if (thumbnails.length) {
    thumbnails.on('initialized.owl.carousel', function() {
      thumbnails.find(".owl-item").eq(0).addClass("current");
    }).owlCarousel({
      navText: '',
      dots: false,
      nav: true,
      mouseDrag: false,
      slideBy: 2,
      items: 4,
      margin: 15

    });

    thumbnails.on("click", ".owl-item", function(e) {
      e.preventDefault();
      var number = $(this).index();
      carousel.trigger("to.owl.carousel", [number, 200, true]);
    });
  }
}

function syncPosition(el, container) {
  var current = el.item.index;
  var thumbnails = container.find('.b-pdp-thumbnail_list');

  thumbnails
    .find(".owl-item")
    .removeClass("current")
    .eq(current)
    .addClass("current");

  var onscreen = thumbnails.find('.owl-item.active').length - 1;
  var start = thumbnails.find('.owl-item.active').first().index();
  var end = thumbnails.find('.owl-item.active').last().index();

  if (current > end) {
    thumbnails.trigger("to.owl.carousel", [current, 200, true]);
  }
  if (current < start) {
    thumbnails.trigger("to.owl.carousel", [current - onscreen, 200, true]);
  }
}

function eventProxy(element, event) {
  return function() {
    $(element || document).trigger('carousel.' + event, this);
  };
}

function initAllCarousels() {
  $(this)
    .find(options.containerSelector)
    .each(initOwlCarousel);
}

// Init owl carousels of recommendation blocks that aren't initialized yet; safe to call repeatedly
function initRecommCarousels($scope) {
  var recommBlocks = ($scope || $(document)).find('.b-product_carousel .owl-carousel:not(.owl-loaded)');
  recommBlocks.each(function() {
    var carouselOptions = $(this).parent('.js-carousel-wrapper').data('carouselOptions');
    $(this).on('initialized.owl.carousel', function(e) {
      e.item.count < e.page.size ? $(this).addClass('owl-hide-controls') : $(this).removeClass('owl-hide-controls');
    });
    $(this).owlCarousel(carouselOptions);
  });
}

function initAllRecommCarousels() {
  // Init owl carousels when Einstein has loaded
  document.addEventListener('recommendations.loaded', function() {
    initRecommCarousels();
  });
}

/**
 * @function
 * @description Destroys Owl Carousels
 * @param {jQuery} [$scope] - limit to carousels inside this element; without it every carousel on the page
 * is destroyed and its wrapper removed (incl. PDP recommendations / last visited)
 */
function destroyOwl($scope) {
  const $container = $scope ? $scope.find(options.containerSelector) : $(options.containerSelector);
  const customConfig = $container.data('carouselOptions') || {};
  const carouselOptions = $.extend({}, options, customConfig);
  const $carousel = $container.find('.' + carouselOptions.baseClass);

  $carousel.each(function () {
    if ($(this).hasClass('owl-loaded')) {
      try {
        $(this).trigger('destroy.owl.carousel');
      } catch (e) {
        console.warn('Failed to destroy owl carousel:', e);
      }

      $(this).removeClass('owl-loaded owl-hidden').find('.owl-stage-outer').children().unwrap();
      $(this).parent('.js-carousel-wrapper').remove();
    }
  });
}

module.exports = {
  init: function(params) {
    initializeParams(params);
    initializeCache();
    initAllCarousels.call(params.container || document);
    initAllRecommCarousels();
  },
  initAllRecommCarousels: function() {
    initAllRecommCarousels();
  },
  initRecommCarousels: initRecommCarousels,
  destroy: destroyOwl
};
